import { frontDoorPath } from "@softmax/web-features/coworlds";

import { site } from "@softmax/web-addresses/discovery";

import { type StorePageContent } from "@/features/store-editor/records";

import type { PreviewCopy } from "../copy/preview-copy.types";

import { type PreviewContent } from "./preview-content.types";

export const previewHeroArt: Record<string, "generals-board"> = {
  "generals-competition": "generals-board",
};

export function applyStorePageOverride(params: {
  blurb: string;
  closingLine: string | null;
  copy: PreviewCopy;
  content: StorePageContent | null;
}): {
  blurb: string;
  closingLine: string | null;
  copy: PreviewCopy;
} {
  const { content, copy } = params;

  if (!content) {
    return { blurb: params.blurb, closingLine: params.closingLine, copy };
  }

  return {
    blurb: content.blurb ?? params.blurb,
    closingLine: content.closing_line ?? params.closingLine,
    copy: {
      ...copy,
      ctaLabel: content.cta_label ?? copy.ctaLabel,
      play: { beats: content.play_beats ?? copy.play.beats },
    },
  };
}

export function previewGameJsonLd(content: PreviewContent): object {
  const url = `${site.canonicalOrigin}${frontDoorPath({ corpusSlug: content.slug.replace(/\/.*$/, ""), route: content.route })}`;
  return {
    "@context": "https://schema.org",
    "@type": "VideoGame",
    name: content.name,
    ...(content.blurb ? { description: content.blurb } : {}),
    url,
    image: `${url}/opengraph-image`,
    ...(content.details.released?.label === "Released"
      ? { datePublished: content.details.released.at }
      : {}),
    ...(content.details.released?.label === "Updated"
      ? { dateModified: content.details.released.at }
      : {}),
  };
}
